function makeId(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charLength = characters.length;
  while (result.length < length) {
    result += characters.charAt(Math.floor(Math.random() * charLength));
  }
  return result + Date.now();
}

class LunaProductForm extends ProductForm {
  constructor() {
    super();

    this.addEventListener("submit", this.handleFormSubmit);
  }

  handleFormSubmit = (event) => {
    if (document.body.classList.contains("cart-template")) return;

    event.preventDefault();
    if (this.submitButtonElement.hasAttribute("aria-disabled")) return;
    this.lastSubmittedElement = event.submitter || event.currentTarget;

    this.displayFormErrors();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const config = FoxTheme.utils.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    this.formData = new FormData(this);
    this.formData.append("sections", sectionsToBundle);
    this.formData.append("sections_url", window.location.pathname);

    config.body = this.formData;

    this.submitButtonElement.setAttribute("aria-disabled", "true");
    this.submitButtonElement.classList.add("btn--loading");

    this.handleFormSubmission(config);
  };

  handleFormSubmission = (config) => {
    // Set unique ID for this line item so it can be
    // tracked across Hydrogen + Shopify Liquid carts
    let isRedirecting = false;

    let handler;
    const resuming = !!(this.dataset.personalizeUid && this.dataset.handle);
    const uniqueId = resuming ? this.dataset.personalizeUid : makeId(5);
    this.publishPersonalizeStarted(uniqueId, resuming);
    if (resuming) {
      // Item already in cart - continuing personalization
      handler = fetch(`${FoxTheme.routes.cart_url}.js`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          const { token: cartToken } = cart;

          isRedirecting = true;
          this.redirectToPersonalization(
            this.dataset.handle,
            this.dataset.personalizeUid,
            cartToken
          );
        });
    } else {
      // New item being added to cart
      config.body.set("properties[_uid]", uniqueId);

      handler = fetch(`${FoxTheme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            this.handleCartError(parsedState);
            return;
          }

          const cartJson = await (
            await fetch(`${FoxTheme.routes.cart_url}`, {
              ...FoxTheme.utils.fetchConfig(),
            })
          ).json();
          cartJson["sections"] = parsedState["sections"];

          this.updateCartState(cartJson);
          this.dispatchProductAddedEvent(parsedState);

          isRedirecting = true;
          this.redirectToPersonalization(
            parsedState.handle,
            uniqueId,
            cartJson.token
          );
        });
    }
    handler
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (isRedirecting) {
          return;
        }

        this.submitButtonElement.classList.remove("btn--loading");
        this.submitButtonElement.removeAttribute("aria-disabled");

        if (!this.hasError) {
          this.submitButtonElement.removeAttribute("aria-disabled");
        }
      });
  };

  // Funnel tracking (Luna funnel custom pixel -> luna_events): ties this visitor's ad/UTM
  // data to the book's _uid, which create.lunabooks.com and checkout also report.
  // Published before the add-to-cart call so it has time to send before the redirect.
  publishPersonalizeStarted = (uniqueId, resuming) => {
    try {
      if (!(window.Shopify && Shopify.analytics && Shopify.analytics.publish)) return;
      Shopify.analytics.publish("personalize_started", {
        uid: uniqueId,
        book: this.dataset.handle || null,
        variant_id: this.formData ? this.formData.get("id") : null,
        resumed: resuming,
      });
    } catch (e) {
      /* tracking must never block personalization */
    }
  };

  redirectToPersonalization = (handle, uniqueId, cartToken) => {
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        // The page was restored from the bfcache - force a reload to reset the form.
        window.location.reload();
      }
    });

    if (!(cartToken && uniqueId && handle)) {
      window.location.href = FoxTheme.routes.cart_url;
      return;
    }

    const url = new URL(`https://create.lunabooks.com/create/${handle}`);
    url.searchParams.set("cart_token", cartToken);
    url.searchParams.set("uid", uniqueId);

    window.location.href = url.toString();
  };

  // No-op
  showCartDrawer = () => {};
}
customElements.define("luna-product-form", LunaProductForm, {
  extends: "form",
});
